import {
  GET_AGILE_PURCHASE_PROVIDERS,
  GET_AGILE_PURCHASE_PROVIDERS_SUCCESS,
  GET_AGILE_PURCHASE_PROVIDERS_ERROR
} from './AgilePurchaseProviders.actions'

const initialState = {
  csv: [],
  data: [],
  loading: false,
  error: null
}
/**
 * Agile Purchase Provider's reducer.
 */
const agilePurchaseProvidersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AGILE_PURCHASE_PROVIDERS:
      return { ...state, loading: true, error: null }
    case GET_AGILE_PURCHASE_PROVIDERS_SUCCESS:
      return { ...state, csv: payload.csv, data: payload.data, loading: false }
    case GET_AGILE_PURCHASE_PROVIDERS_ERROR:
      return { ...state, loading: false, error: payload.error, data: [] }
    default:
      return state
  }
}

export default agilePurchaseProvidersReducer
